import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { HelmetProvider } from 'react-helmet-async';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';

import { routesSection } from 'src/routes/sections';

import { msalInstance } from 'src/lib/msal';
import { themeConfig, ThemeProvider } from 'src/theme';

import { defaultSettings, SettingsProvider } from 'src/components/settings';

import App from './App';
import { ErrorBoundary } from './routes/components';
import { installBrowserErrorFilters } from './lib/browserErrorFilters';

// Install filters for known, harmless browser error messages.
// This keeps the console clean from noisy errors (like the ResizeObserver bug)
// while still surfacing all real issues.
installBrowserErrorFilters();

const router = createBrowserRouter([
  {
    Component: () => (
      <App>
        <Outlet />
      </App>
    ),
    errorElement: <ErrorBoundary />,
    children: routesSection,
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <MsalProvider instance={msalInstance}>
        <SettingsProvider defaultSettings={defaultSettings}>
          <ThemeProvider noSsr defaultMode="light" modeStorageKey={themeConfig.modeStorageKey}>
            <RouterProvider router={router} />
          </ThemeProvider>
        </SettingsProvider>
      </MsalProvider>
    </HelmetProvider>
  </React.StrictMode>
);
